/**
 * @generated SignedSource<<28d350427cdb23492ea23bd865857d0d>>
 * @relayHash 5df300ccb9cc080673098b138d8fa4fb
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

// @relayRequestID 06150c82ff93b0c8ff1a217a6d57ebff20cde2e8ac41530ba515c60d1503f539

import type { ConcreteRequest, Query } from 'relay-runtime';
import type { FragmentRefs } from "relay-runtime";
export type JiraWorkManagementFilterSearchInput = {
  contextId: string;
  favoritesOnly?: boolean | null | undefined;
  keyword?: string | null | undefined;
};
export type FiltersMenuContentQuery$variables = {
  first?: number | null | undefined;
  searchParameters: JiraWorkManagementFilterSearchInput;
};
export type FiltersMenuContentQuery$data = {
  readonly jira: {
    readonly jwmFilters: {
      readonly edges?: ReadonlyArray<{
        readonly node: {
          readonly id: string;
          readonly name: string;
          readonly " $fragmentSpreads": FragmentRefs<"SavedFilterMenuItem_filter">;
        };
      } | null | undefined>;
      readonly message?: string | null | undefined;
    };
  };
};
export type FiltersMenuContentQuery = {
  response: FiltersMenuContentQuery$data;
  variables: FiltersMenuContentQuery$variables;
};

const node: ConcreteRequest = (function(){
var v0 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "first"
},
v1 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "searchParameters"
},
v2 = [
  {
    "kind": "Variable",
    "name": "first",
    "variableName": "first"
  },
  {
    "kind": "Variable",
    "name": "searchParameters",
    "variableName": "searchParameters"
  }
],
v3 = {
  "kind": "ScalarField",
  "name": "id"
},
v4 = {
  "kind": "ScalarField",
  "name": "name"
},
v5 = {
  "kind": "InlineFragment",
  "selections": [
    {
      "kind": "ScalarField",
      "name": "message"
    }
  ],
  "type": "QueryError"
};
return {
  "fragment": {
    "argumentDefinitions": [
      (v0/*: any*/),
      (v1/*: any*/)
    ],
    "kind": "Fragment",
    "name": "FiltersMenuContentQuery",
    "selections": [
      {
        "kind": "RequiredField",
        "field": {
          "concreteType": "JiraQuery",
          "kind": "LinkedField",
          "name": "jira",
          "plural": false,
          "selections": [
            {
              "kind": "RequiredField",
              "field": {
                "args": (v2/*: any*/),
                "kind": "LinkedField",
                "name": "jwmFilters",
                "plural": false,
                "selections": [
                  {
                    "kind": "InlineFragment",
                    "selections": [
                      {
                        "kind": "RequiredField",
                        "field": {
                          "concreteType": "JiraWorkManagementFilterEdge",
                          "kind": "LinkedField",
                          "name": "edges",
                          "plural": true,
                          "selections": [
                            {
                              "kind": "RequiredField",
                              "field": {
                                "concreteType": "JiraWorkManagementFilter",
                                "kind": "LinkedField",
                                "name": "node",
                                "plural": false,
                                "selections": [
                                  {
                                    "kind": "FragmentSpread",
                                    "name": "SavedFilterMenuItem_filter"
                                  },
                                  {
                                    "kind": "RequiredField",
                                    "field": (v3/*: any*/),
                                    "action": "THROW",
                                    "path": "jira.jwmFilters.edges.node.id"
                                  },
                                  {
                                    "kind": "RequiredField",
                                    "field": (v4/*: any*/),
                                    "action": "THROW",
                                    "path": "jira.jwmFilters.edges.node.name"
                                  }
                                ]
                              },
                              "action": "THROW",
                              "path": "jira.jwmFilters.edges.node"
                            }
                          ]
                        },
                        "action": "THROW",
                        "path": "jira.jwmFilters.edges"
                      }
                    ],
                    "type": "JiraWorkManagementFilterConnection"
                  },
                  (v5/*: any*/)
                ]
              },
              "action": "THROW",
              "path": "jira.jwmFilters"
            }
          ]
        },
        "action": "THROW",
        "path": "jira"
      }
    ],
    "type": "Query"
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": [
      (v1/*: any*/),
      (v0/*: any*/)
    ],
    "kind": "Operation",
    "name": "FiltersMenuContentQuery",
    "selections": [
      {
        "concreteType": "JiraQuery",
        "kind": "LinkedField",
        "name": "jira",
        "plural": false,
        "selections": [
          {
            "args": (v2/*: any*/),
            "kind": "LinkedField",
            "name": "jwmFilters",
            "plural": false,
            "selections": [
              {
                "kind": "ScalarField",
                "name": "__typename"
              },
              {
                "kind": "InlineFragment",
                "selections": [
                  {
                    "concreteType": "JiraWorkManagementFilterEdge",
                    "kind": "LinkedField",
                    "name": "edges",
                    "plural": true,
                    "selections": [
                      {
                        "concreteType": "JiraWorkManagementFilter",
                        "kind": "LinkedField",
                        "name": "node",
                        "plural": false,
                        "selections": [
                          (v3/*: any*/),
                          (v4/*: any*/),
                          {
                            "kind": "ScalarField",
                            "name": "jql"
                          },
                          {
                            "kind": "ScalarField",
                            "name": "isEditable"
                          }
                        ]
                      }
                    ]
                  }
                ],
                "type": "JiraWorkManagementFilterConnection"
              },
              (v5/*: any*/)
            ]
          }
        ]
      }
    ]
  },
  "params": {
    "id": "06150c82ff93b0c8ff1a217a6d57ebff20cde2e8ac41530ba515c60d1503f539",
    "metadata": {},
    "name": "FiltersMenuContentQuery",
    "operationKind": "query",
    "text": null
  }
};
})();

(node as any).hash = "d092ab1b292a8d5a989b24047c8ee647";

export default node;
